module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rows"
  }, _vm._l((_vm.materiels.data), function(materiel) {
    return _c('div', {
      key: materiel.id,
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-4"
    }, [_c('span', {
      staticClass: "title-item"
    }, [_vm._v("Numero unique")]), _vm._v(" "), _c('span', {
      staticClass: "text-item"
    }, [_vm._v(_vm._s(materiel.nom))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3"
    }, [_c('span', {
      staticClass: "title-item"
    }, [_vm._v("Arrondissement de rattachement")]), _vm._v(" "), _c('span', {
      staticClass: "text-item"
    }, [_vm._v("\n        " + _vm._s(_vm._f("arrondissementName")(materiel.arrondissement_id)) + "\n      ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3"
    }, [_c('span', {
      staticClass: "title-item"
    }, [_vm._v("Type")]), _vm._v(" "), _c('span', {
      staticClass: "text-item"
    }, [_vm._v("\n        " + _vm._s(materiel.materielType) + "\n      ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2"
    }, [_c('div', {
      staticClass: "actions"
    }, [_c('a', {
      staticClass: "action-edit",
      on: {
        "click": function($event) {
          return _vm.$emit('edit', materiel)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../../../static/img/edit-icon.svg")
      }
    })]), _vm._v(" "), _c('a', {
      staticClass: "action-delete right-separator",
      on: {
        "click": function($event) {
          return _vm.$emit('delete', materiel)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../../../static/img/delete-icon.svg")
      }
    })])])])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5c2adbfe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/materiel/MaterielList.vue
// module id = 2109
// module chunks = 2